import { createGlobalStyle } from 'styled-components'

import { resets } from './resets.styles'

export const GlobalStyle = createGlobalStyle`
  ${resets}
`
